import { apiClient } from "@/api/api-client";

export type BomBrandOrigin = {
    id: number;
    brand_origin_name: string;
};

const bomBrandOriginService = {
    list: async (): Promise<BomBrandOrigin[]> => {
        const response = await apiClient.get<BomBrandOrigin[]>("/bom/brand-origins");
        return response.data;
    },
};

export default bomBrandOriginService;
